import { byPrefixAndName } from '@awesome.me/kit-f16c5d7bca/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import _ from 'lodash'

// "title" field is added for Vuexy - should duplicate name field
const organizationNavigation = () => [
  {
    name: 'Dashboard',
    title: 'Dashboard',
    id: 'dashboard',
    navLink: '/dashboard',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['wave-pulse']} />,
    badge: {
      variant: 'info',
      text: ''
    }
  },
  {
    name: 'Org Admins',
    id: 'admins',
    title: 'Org Admins',
    navLink: '/organization_admins',
    entity: 'ADMIN',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['mug-hot']} />,
    permissions: ['ADMIN.read'],
    children: [
      {
        name: 'Admins List',
        id: 'adminList',
        title: 'Admin List',
        navLink: '/organization_admins',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ADMIN.read']
      },
      {
        name: 'Admin Roles',
        title: 'Marketfuel Roles',
        id: 'orgAdminRoles',
        navLink: '/org_roles',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ORG_PERMISSIONS.read']
      }
    ]
  },
  {
    name: 'Agencies',
    title: 'Agencies',
    navLink: '/agencies',
    id: 'agencies',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['database']} />,
    permissions: ['AGENCIES.read']
  },

  {
    name: 'Async Errors',
    id: 'errors',
    title: 'Async Errors',
    navLink: '/async_error_logs',
    entity: 'ORG_PERMISSIONS',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['octagon-exclamation']} />,
    permissions: ['ORG_PERMISSIONS.read'],
    children: [
      {
        name: 'General Errors',
        id: 'assync_errors',
        title: 'General Errors',
        navLink: '/async_error_logs',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ORG_PERMISSIONS.read']
      },
      {
        name: 'Order Errors',
        id: 'OrderErrorsGrid',
        title: 'Order Errors',
        navLink: '/orders/errors',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ORG_PERMISSIONS.read']
      }
    ]
  },
  // {
  //   name: 'Order Async Errors',
  //   id: 'OrderErrorsGrid',
  //   title: 'Order Errors',
  //   navLink: '/orders/errors',
  //   icon: <Icon.AlertTriangle />,
  //   permissions: ['ORG_PERMISSIONS.read']
  // },
  {
    name: 'Reporting',
    id: 'reporting',
    title: 'Reporting',
    // navLink: '/reporting',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['chart-pie']} />,
    permissions: ['REPORTING.read']
  }
]

const clientAdminNavigation = () => [
  {
    name: 'Order Review',
    title: 'Order Review',
    id: 'orderRevierAadmin',
    navLink: '/orders/review',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['circle-check']} />,
    permissions: ['ORDER_APPROVAL.update', 'ORDER.read']
  }
]

const agencyNavigation = (skin, admin) => [
  {
    name: 'Dashboard',
    title: 'Dashboard',
    id: 'dashboard',
    navLink: '/dashboard',
    icon: (
      <FontAwesomeIcon
        style={{ width: '1rem' }}
        icon={byPrefixAndName['fad'][`house-${skin === 'dark' ? 'night' : 'day'}`]}
      />
    ),
    badge: {
      variant: 'info',
      text: ''
    }
  },
  {
    name: 'Account',
    id: 'account',
    title: 'Account',
    navLink: '/',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['gears']} />,
    permissions: ['ADMIN.read'],
    children: [
      {
        name: 'General Info',
        id: 'generalInfo',
        title: 'General Info',
        // navLink: '/',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ADMIN.read']
      },
      {
        name: 'Settings',
        id: 'settings',
        title: 'Settings',
        // navLink: '/settings',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ADMIN.read']
      },
      {
        name: 'Team',
        id: 'team',
        title: 'Team',
        navLink: '/team',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ADMIN.read'],
        children: [
          {
            name: 'Admins',
            id: 'adminsGrid',
            title: 'Admins',
            navLink: '/admins',
            icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
            permissions: ['ADMIN.read']
          },
          {
            name: 'Admin Roles',
            title: 'Admin Roles',
            id: 'adminRoles',
            navLink: '/roles',
            icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
            permissions: ['PERMISSIONS.read']
          }
        ]
      },
      {
        name: 'Billing',
        id: 'billing',
        title: 'Billing',
        // navLink: '/billing',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ADMIN.read']
      },
      {
        name: 'Integrations',
        id: 'integrations',
        title: 'Integrations',
        // navLink: '/integrations',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ADMIN.read']
      },
      {
        name: 'Carriers',
        id: 'carriers',
        title: 'Carriers',
        // navLink: '/carriers',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ADMIN.read']
      }
    ]
  },
  // {
  //   name: 'Admins',
  //   id: 'admins',
  //   title: 'Admin',
  //   navLink: '/admins',
  //   entity: 'ADMIN',
  //   icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['gears']} />,
  //   permissions: ['ADMIN.read'],
  //   children: [
  //     {
  //       name: 'Admins',
  //       id: 'adminsGrid',
  //       title: 'Admins',
  //       navLink: '/admins',
  //       icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
  //       permissions: ['ADMIN.read']
  //     },
  //     {
  //       name: 'Admin Roles',
  //       title: 'Admin Roles',
  //       id: 'adminRoles',
  //       navLink: '/roles',
  //       icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
  //       permissions: ['PERMISSIONS.read']
  //     }
  //   ]
  // },
  {
    name: 'Clients',
    title: 'Clients',
    id: 'clients_v2',
    entity: 'CLIENT',
    navLink: '/clients',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['building-magnifying-glass']} />,
    permissions: ['CLIENT.read', 'PORTAL.read']
  },
  {
    name: 'Portals',
    title: 'Portals',
    id: 'portals',
    entity: 'PORTAL',
    navLink: '/portals',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['person-to-portal']} />,
    permissions: [
      'PORTAL.read',
      'PORTAL_CREDIT.read',
      'LOCATION.read',
      'CMS.read',
      'COOP_FUNDING.read',
      'COOP_CREDIT.read',
      'CUST_GROUPS.read'
    ]
  },

  {
    name: 'Customers',
    title: 'Customers',
    id: 'customers',
    navLink: '/customers',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['users']} />,
    permissions: ['USER.read', 'GIFT_CARD.read', 'COOP_CREDIT.read', 'PORTAL_CREDIT.read']
  },
  {
    name: 'Products',
    title: 'Products',
    id: 'products',
    navLink: '/products',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['cake-slice']} />,
    permissions: ['PRODUCT.read', 'PRODUCT_WIZARD.create', 'BUNDLE_WIZARD.create'],
    children: [
      {
        name: 'Products',
        title: 'Products',
        id: 'productsGrid',
        navLink: '/products',
        entity: 'PRODUCT',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['PRODUCT.read', 'PRODUCT_WIZARD.create', 'BUNDLE_WIZARD.create']
      },
      {
        name: 'Artworks',
        title: 'Artworks',
        id: 'artworksList',
        navLink: '/artworks',
        entity: 'ARTWORK',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['PRODUCT.read']
      },
      {
        name: 'Configuration',
        title: 'Configuration',
        id: 'configuration',
        navLink: '/products/configurable_variants',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['PRODUCT.read']
      },
      {
        name: 'Product Templates',
        title: 'Product Templates',
        id: 'productTemplates',
        navLink: '/templates',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['PRODUCT.read']
      },
      {
        name: 'ShipperHQ',
        id: 'ShipperHQ',
        title: 'ShipperHQ',
        navLink: '/',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ORDER.read'],
        children: [
          {
            name: 'Boxes',
            id: 'ShipperHqList',
            title: 'Boxes',
            navLink: '/products/shq_boxes',
            icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
            permissions: ['ORDER.read']
          },

          {
            name: 'Origins',
            id: 'ShipperHqOriginList',
            title: 'Origins',
            navLink: '/products/shq_origins',
            icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
            permissions: ['ORDER.read']
          },
          // {
          //   name: 'Fulfillment',
          //   id: 'fulfillment',
          //   title: 'Fulfillment',
          //   navLink: '/fulfilment',
          //   icon: <Icon.ChevronRight size='1.01rem' />,
          //   permissions: ['ORDER.read']
          // },
          {
            name: 'Groups',
            id: 'ShipperHqGroupsList',
            title: 'Groups',
            navLink: '/products/shq_shipping_groups',
            icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
            permissions: ['ORDER.read']
          },
          {
            name: 'Rules',
            id: 'ShipperHqRulesist',
            title: 'Rules',
            navLink: '/products/shq_packing_rules',
            icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
            permissions: ['ORDER.read']
          }
        ]
      }
    ]
  },
  {
    name: 'Orders',
    id: 'orders',
    title: 'Orders',
    navLink: '/orders',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['cart-shopping']} />,
    permissions: ['ORDER.read'],
    children: [
      {
        name: 'Orders',
        id: 'ordersGrid',
        title: 'Orders',
        navLink: '/orders',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ORDER.read']
      },
      {
        name: 'Fulfillment',
        id: 'fulfillment',
        title: 'Fulfillment',
        navLink: '/fulfillment',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ORDER.read']
      },
      {
        name: 'Dropshipping',
        id: 'dropship',
        title: 'Dropshipping',
        navLink: '/dropship',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ORDER.read']
      },
      {
        name: 'Order Review',
        title: 'Order Review',
        id: 'orderApproval',
        navLink: '/orders/review',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ORDER_APPROVAL.read', 'ORDER.read']
        // permissions: [ 'ORDER.read'],
      },
      {
        name: 'Log',
        id: 'OrderLogsList',
        title: 'Orders Logs',
        navLink: '/orders/log',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['ORDER.read']
      }
    ]
  },
  {
    name: 'Stock Mgmt',
    title: 'Stock Mgmt',
    navLink: '/stock',
    id: 'stock',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['warehouse-full']} />,
    permissions: ['WAREHOUSE.read', 'PURCHASE_ORDER.read', 'VENDORS.read'],
    children: [
      {
        name: 'Warehouses',
        title: 'Warehouses',
        id: 'warehouses',
        entity: 'WAREHOUSE',
        navLink: '/warehouses',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['WAREHOUSE.read']
      },
      {
        name: 'Purchase Orders',
        title: 'Purchase Orders',
        entity: 'PURCHASE_ORDER',
        id: 'purchase_order',
        navLink: '/purchase_orders',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['PURCHASE_ORDER.read']
      },
      {
        name: 'Vendors',
        title: 'Vendors',
        id: 'vendors',
        entity: 'VENDORS',
        navLink: '/vendors',
        icon: <FontAwesomeIcon size="xs" icon={byPrefixAndName['fad']['chevron-right']} />,
        permissions: ['VENDORS.read']
      }
    ]
  },
  {
    name: 'Promotions',
    id: 'promotions',
    title: 'Promotions',
    navLink: '/promotions',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['badge-percent']} />,
    permissions: ['COUPON.read']
  },
  {
    name: 'Reporting',
    id: 'reporting',
    title: 'Reporting',
    // navLink: '/reporting',
    icon: <FontAwesomeIcon style={{ width: '1rem' }} icon={byPrefixAndName['fad']['chart-pie']} />,
    permissions: ['REPORTING.read']
  }
  // {
  //   name: 'Integrations',
  //   id: 'integrations',
  //   title: 'Integrations',
  //   navLink: '/integrations',
  //   icon: <i className="fa-duotone fa-diagram-project menu-duotone-icon-8" />,
  //   permissions: ['REPORTING.read']
  // }
  // {
  //   name: 'Feedback',
  //   id: 'feedback',
  //   title: 'Feedback',
  //   navLink: `https://feedback.marketfuel.com/changelog?jwt=${admin.featurebase_authentication_token}`,
  //   newTab: true,
  //   externalLink: true,
  //   icon: <FontAwesomeIcon size='md' icon={byPrefixAndName['fad']['lightbulb-on']} />,
  //   style: { marginTop: 'auto' }
  // }
]

// returns the starting navigation object, before considering permissions
// there are three types: organization, client admin, and agency
const navigation = (skin, admin, agency) => {
  let navItems = []
  // only show org view if logged out of agency
  if (admin.organization_admins?.length > 0 && !agency?.id) {
    navItems = organizationNavigation()
  } else if (admin.is_client_admin) {
    navItems = clientAdminNavigation()
  } else {
    navItems = agencyNavigation(skin, admin)
  }

  return { items: navItems }
}

// filters out nav tabs that should be hidden based on admin role
const getNavigationForAdmin = (permissions, admin, skin = 'light', agency) => {
  const isSuperAdmin = permissions === false || admin.logged_in_as === 'Organization' || admin.is_super_admin
  const nav = navigation(skin, admin, agency)

  if (isSuperAdmin) {
    return nav // Super admin - return all navigation items (no filtering)
  }

  // Filter navigation items based on user permissions
  const filteredNavigationItems = nav.items.filter(item => {
    if (!item.permissions) {
      // Include item if it does not require permissions
      return true
    }

    // Filter out childrens based on permissions
    const children = (item.children || []).filter(child => {
      if (!child.permissions) {
        return true
      }

      return child.permissions.some(requiredPermission => permissions.includes(requiredPermission))
    })

    if (children.length !== 0) {
      item.children = children
    }

    // Check if user has at least one of the required permissions for this item
    return item.permissions.some(requiredPermission => permissions.includes(requiredPermission))
  })

  // Clone the navigation object to avoid mutating the original
  const navigationClone = _.cloneDeep(nav)
  navigationClone.items = filteredNavigationItems

  return navigationClone
}

export default getNavigationForAdmin
